import { Routes } from '@angular/router'
import { NotFoundComponent } from './not-found/not-found.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './guards/auth.guards';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ClienteComponent } from './cliente/cliente.component';
import { ProdutoComponent } from './produto/produto.component';
import { HomeComponent } from './home/home.component';
import { FinanceiroComponent } from './financeiro/financeiro.component';
import { ComercialComponent } from './comercial/comercial.component';
import { CarteiraComponent } from './carteira/carteira.component';
import { TecnicaComponent } from './tecnica/tecnica.component';
import { CentralComponent } from './central/central.component';
import { VistoriaComponent } from './vistoria/vistoria.component';
import { VistoriaManutencaoComponent } from './vistoria-manutencao/vistoria-manutencao.component';
import { FaturamentoComponent } from './faturamento/faturamento.component';
import { LocalizacaoChamadaComponent } from './localizacao/localizacao-chamada/localizacao-chamada.component';
import { LocalizacaoTecnicoComponent } from './localizacao/localizacao-tecnico/localizacao-tecnico.component';
import { LocalizacaoTecnicoClienteComponent } from './localizacao/localizacao-tecnico-cliente/localizacao-tecnico-cliente.component';
import { LocalizacaoClienteComponent } from './localizacao/localizacao-cliente/localizacao-cliente.component';

export const ROUTES: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: '', component: DashboardComponent, canActivate: [AuthGuard],
        children: [
            //{ path: '', redirectTo: 'home', pathMatch: 'full', canActivate: [AuthGuard] },
            //{ path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
            { path: 'faturamento', component: FaturamentoComponent, canActivate: [AuthGuard] },
            { path: 'financeiro', component: FinanceiroComponent, canActivate: [AuthGuard] },
            // { path: 'cliente', component: ClienteComponent, canActivate: [AuthGuard] },
            // { path: 'produto', component: ProdutoComponent, canActivate: [AuthGuard] },
            { path: 'comercial', component: ComercialComponent, canActivate: [AuthGuard] },
            { path: 'carteira', component: CarteiraComponent, canActivate: [AuthGuard] },
            { path: 'tecnica', component: TecnicaComponent, canActivate: [AuthGuard] },
            { path: 'central', component: CentralComponent, canActivate: [AuthGuard] },
            // { path: 'vistoria', component: VistoriaComponent, canActivate: [AuthGuard] },
            // { path: 'vistoria-manutencao', component: VistoriaManutencaoComponent, canActivate: [AuthGuard] },
            { path: 'localizacao-tecnico', component: LocalizacaoTecnicoComponent, canActivate: [AuthGuard] },
            // { path: 'localizacao-chamada', component: LocalizacaoChamadaComponent, canActivate: [AuthGuard] },
            // { path: 'localizacao-cliente-tecnico', component: LocalizacaoTecnicoClienteComponent, canActivate: [AuthGuard] },
            // { path: 'localizacao-cliente', component: LocalizacaoClienteComponent, canActivate: [AuthGuard] },
            
        ]
    },
    { path: '**', component: NotFoundComponent }
]